import { useQuery } from "@tanstack/react-query";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { Spinner } from "@/components/ui/spinner";
import useTheme from "hooks/useTheme";
import { useCallDashboardFilters } from "routes/dashboard/useCallDashboardFilters";
import DashboardService from "services/Dashboard";

const getTotalCallsBarChart = async ({ queryKey = [] }) => {
  const [, filters] = queryKey;

  const resp = await DashboardService.getTotalCallsBarChart(filters);
  return resp.data ?? [];
};

function TotalCallsChart() {
  const [queryFilters] = useCallDashboardFilters();
  const { data, isFetching } = useQuery({
    initialData: [],
    queryKey: ["call-dashboard-total-calls", queryFilters],
    queryFn: getTotalCallsBarChart,
  });
  const { isDark } = useTheme();
  const axisColor = isDark ? "#b0b0b0" : "#666";
  const gridColor = isDark ? "#404040" : "#ccc";

  return (
    <div className="tw:relative tw:h-full tw:w-full">
      {isFetching && (
        <Spinner className="tw:absolute tw:top-1/2 tw:left-1/2 tw:z-10 tw:size-8 tw:-translate-x-1/2 tw:-translate-y-1/2" />
      )}
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="4 2 4" stroke={gridColor} />
          <XAxis dataKey="day" tick={{ fill: axisColor }} />
          <YAxis tick={{ fill: axisColor }} />
          <Tooltip
            cursor={{
              fill: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
            }}
            contentStyle={{
              backgroundColor: isDark ? "#2d2d2d" : "#fff",
              borderColor: isDark ? "#404040" : "#ccc",
              color: isDark ? "#e8e8e8" : "#333",
            }}
            labelStyle={{ color: isDark ? "#e8e8e8" : "#333" }}
          />
          <Bar dataKey="num_dials" fill="#ff6b35" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TotalCallsChart;
